import React from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import * as Yup from 'yup';
import {TState} from '../../../../../redux/store.type';
import NewEventForm from '../../../../newEvent/components/newEventForm/NewEventForm';
import {newEventInitialValues, newEventSteps, newEventValidationSchema} from '../../../../newEvent/globalSteps';

function CreateSubscriptionEvent() {
    const event = useSelector((s:TState) => s.event);
    const {t} = useTranslation(['global', 'newEvent', 'errors', 'layout']);

    // Define steps for subscription
    const subscriptionSteps = {
        title: {
            ...newEventSteps.title,
            texts: {
                header: '',
                description: ''
            },
            compProps: {
                text: 'subscriptionTitleText',
                description: 'subscriptionTitleDesc'
            },
            // name: 'subscriptionTitle'
        },
        date: {
            ...newEventSteps.simpleDate,
            texts: {
                header: 'subscriptionDateHeader'
            }
        },
        location: {
            ...newEventSteps.location,
            texts: {
                header: 'subscriptionLocationHeader'
            }
        },
        description: {
            ...newEventSteps.description,
            texts: {
                description: 'subscriptionDescriptionDesc',
                header: 'description'
            }
        },
        fullDescription: {
            ...newEventSteps.fullDescription,
            texts: {
                header: 'subscriptionFullDescriptionHeader',
                description: 'subscriptionFullDescriptionDesc'
            }
        },
        category: {
            ...newEventSteps.category(t),
            texts: {
                header: 'subscriptionCategoryHeader'
            }
        }
    };

    const {title, description, locale, location, date, fullDescription} = newEventInitialValues(event);

    const initialValues = {
        title,
        description,
        locale,
        location,
        date,
        fullDescription,
        category: event.category || []
    };

    const {title: titleValid, description: descriptionValid, locale: localValid, location: locationValid} = newEventValidationSchema(t);

    const initialValidationSchema = Yup.object().shape({
        title: titleValid,
        description: descriptionValid,
        locale: localValid,
        location: locationValid,
        fullDescription: descriptionValid,
        category: Yup.array().of(Yup.number().required()).min(1).required()
    });

    return (
        <NewEventForm
            initialValues={initialValues}
            validationSchema={initialValidationSchema}
            steps={Object.values(subscriptionSteps)}
        />
    );
}

export default CreateSubscriptionEvent;
